import { configureStore } from "@reduxjs/toolkit";
import userTokenSlice from "./slices/userTokenSlice";

import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import timeSlice from "./slices/timeSlice";
import questionsSlice from "./slices/questionsSlice";
import indexSlice from "./slices/indexSlice";
import opponentPlayerSlice from "./slices/opponentPlayerSlice";
import userPlayerSlice from "./slices/userPlayerSlice";
import languageSlice from "./slices/languageSlice";

const rootReducer = combineReducers({
  userTokenSlice: userTokenSlice.reducer,
  opponentPlayerSlice: opponentPlayerSlice.reducer,
  timeSlice: timeSlice.reducer,
  questionsSlice: questionsSlice.reducer,
  indexSlice: indexSlice.reducer,
  userPlayerSlice: userPlayerSlice.reducer,

});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: {
    persisted: persistedReducer,
    languageSlice: languageSlice.reducer
  },
});

export default store;
export const persistor = persistStore(store);